module.exports = __webpack_public_path__ + "static/media/slide (4).30658d37.jpg";